import { render, staticRenderFns } from "./listBanking.vue?vue&type=template&id=2675f1d0&scoped=true"
import script from "./listBanking.vue?vue&type=script&lang=js"
export * from "./listBanking.vue?vue&type=script&lang=js"
import style0 from "./listBanking.vue?vue&type=style&index=0&id=2675f1d0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675f1d0",
  null
  
)

export default component.exports